import _ from 'lodash';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';

export function formatAssertionsForDisplayTaskWcgw(assertions) {
	let assertionsToUpdate = [];
	Object.assign(assertionsToUpdate, assertions);

	if (assertions && assertions.length > 0 && assertions.length < 5) {
		let assertionKnowledgeIds = assertionsToUpdate.map((a) => {
				return a.knowledgeAssertionId;
			}),
			emptyAssertion = {
				assertionName: '',
				assertionAbbreviation: '',
				accountId: 0,
				assertionId: 0,
				inherentRiskTypeId: 0,
				controlRiskTypeId: 0,
				hasRiskAssociated: false,
				accountName: null,
				knowledgeAssertionId: 6,
				craValue: '',
				validationStatus: null,
				validationMessages: null,
				displayOrder: 0,
				id: 0,
				notForDisplay: true
			};

		if (!assertionKnowledgeIds.some((v) => [6, 1, 10].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(0, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [7, 2, 11].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(1, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [8, 3, 12].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(2, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [4, 13].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(3, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [9, 5, 14].indexOf(v) !== -1)) {
			assertionsToUpdate.splice(4, 0, emptyAssertion);
		}
	}
	return assertionsToUpdate;
}

export function wcgwReducer(state = initialstate.wcgws, action) {
	switch (action.type) {
		case types.GET_WCGWS: {
			return action.response || state;
		}
		case types.GET_WCGWS_BY_SCOTID: {
			let wcgws = [...action.response?.wcgWs];
			return wcgws;
		}
		case types.UPDATE_WCGW:
			if (!_.isEmpty(action.response)) {
				let newState = _.cloneDeep(state);
				const editIndex = newState?.findIndex((x) => x.wcgwId === action.response.id);
				newState[editIndex] = {...newState[editIndex], wcgwName: action.response.wcgwName};
				return newState;
			}
			return state;
		case types.DELETE_WCGW_BY_ID: {
			if (isApiResponseOk(action) || action.error.response.status === HttpStatusCodes.NotFound) {
				let newState = _.cloneDeep(state);
				newState = newState?.filter((wcgw) => wcgw.wcgwId != Number(action.wcgwId));
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}

export function wcgwAddUpdateReducer(state = initialstate.wcgwDetails, action) {
	switch (action.type) {
		case types.ADD_WCGW:
			return {
				...state,
				...action.response,
				createdWCGW: action.response
			};
		case types.GET_WCGW_BY_ID:
			if (isApiResponseOk(action)) {
				return {
					...state,
					...action.response,
					selectedWCGW: action.response
				};
			}
			return state;
		case types.CLEAR_WCGW: {
			return {
				...state,
				selectedWCGW: null,
				createdWCGW: null
			};
		}
		default:
			return state;
	}
}
